// 상단바 기수·회사 선택 목록 — basicinfo-service 의 /api/basicinfo/common/{gisus,companies}.
// 경로는 관리자 사용량 API 와 같은 규칙이다(adminUsage.ts): 게이트웨이가 서빙하는 origin 에서만
// 절대 URL, 로컬에서는 상대경로로 dev 프록시(/chat-api → 게이트웨이)를 탄다.
import { GW_ORIGIN } from 'yukimushi-component-fe';
import { authorizedFetch } from './auth';

const SERVED_BY_GATEWAY = window.location.hostname.indexOf('gennolab.co.jp') >= 0;
const BASE = `${SERVED_BY_GATEWAY ? GW_ORIGIN : ''}/chat-api/api/basicinfo`;

export interface GisuDto {
  gisu: number;
  startDa: string | null;
  endDa: string | null;
  closeYn: boolean;
}

export interface ComDto {
  comSq: number;
  nm: string;
  comTy: number | null;
  taxOfficeTy: number | null;
  gisu: number | null;
  /** 로그인 소속 회사면 true — 서버가 아직 안 주면(옛 배포) undefined */
  current?: boolean;
}

async function getList<T>(path: string): Promise<T[]> {
  const res = await authorizedFetch(`${BASE}${path}`);
  if (!res.ok) throw new Error(`${path} ${res.status}`);
  const body = await res.json();
  // 배포본에서 라우트가 없으면 SPA fallback(index.html)이 200 으로 올 수 있다 — 배열이 아니면 실패로 본다
  if (!Array.isArray(body)) throw new Error('데이터를 불러오지 못했습니다');
  return body as T[];
}

export const fetchGisus = () => getList<GisuDto>('/common/gisus');
export const fetchCompanies = () => getList<ComDto>('/common/companies');
